<template>
  <DashView>
  <div class="invoice-box" id="">
  <div class="d-flex justify-content-between invoice-header">
    <div>
      <h1 class="invoice-title">Facture</h1>
      <p><strong>{{ infoEntreprise.nom }}</strong><br>
        {{ infoEntreprise.adresse }}<br>
        {{ infoEntreprise.telephone }}<br>
        {{ infoEntreprise.email }}</p>
    </div>
    <div>
        <img src="https://via.placeholder.com/120x70?text=Logo" alt="Logo Clinique" class="clinic-logo mb-2">
        <p>
          <!-- <strong>Facture N° :</strong> {{ facture }}<br> -->
          <strong>Date :</strong> {{ dateDuJour }}
        </p>
    </div>
  </div>

  <div class="mb-4">
    <h5>Informations du Patient</h5>
    <div class="row">
      <div class="col-md-6">
        <p>
          <strong>Nom Complet :</strong> {{ donnees?.patient?.nom }} {{ donnees?.patient?.prenom }}<br>
           <strong>ID Patient :</strong> {{ donnees?.patient?.code_dossier }}<br>
           <strong>Date de Naissance :</strong> {{ donnees?.patient?.date_naiss }}<br>
           <strong>Sexe :</strong> {{ donnees?.patient?.sexe=== 1 ? 'Masculin' : 'Féminin' }}
        </p>
      </div>
      <div class="col-md-6">
        <p><strong>Téléphone :</strong> {{ donnees?.patient?.phone}}<br>
           <strong>Adresse :</strong> {{ donnees?.patient?.adresse }}</p>
      </div>
    </div>
  </div>

  <h5>Services facturés</h5>
      <p>{{ services.service }} {{ donnees.specialite.specialite }}: {{ donnees.prixTotal }} Gourdes</p>
      <p style="text-decoration: underline;">Prix total:<b>{{ donnees.prixTotal }} Gourdes</b></p>
  

  <p class="mt-3"><strong>Note :</strong> Merci pour votre visite. Pour toute question, veuillez contacter le secrétariat.</p>

  <div class="text-center mt-3 mb-5 pb-5 no-print">
    <div class="alert alert-info">Choisis format d'impression avant l'enregistrement!</div>
    <div class="row">    
    <div class="col-md-4">
        <select class="form-select" id="printType" v-model="printType">
            <option value="">-- <i class="bi bi-printer me-1"></i> Format printer--</option>
            <option value="lettre">Format Lettre</option>
            <option value="thermal">Format Thermal</option>
        </select>
    </div>
    <div class="col-md-4">
        <button @click="registerFacture" class="btn btn-primary me-2" v-if="printType!=''">
            <i class="fa fa-save text-white"></i> Enrégistrer
      </button>
    </div>
      

    </div>

      <!-- <template v-if="save">
        <button @click="printDivBureau" class="btn btn-primary me-2">
        <i class="bi bi-printer"></i>Grand Format
      </button>

      <button @click="printDivThermal" class="btn btn-secondary">
        <i class="bi bi-printer-fill"></i> Format thermique
      </button>
      </template> -->
      
  </div>

  <!-- Div Print Bureau begin-->
  <div style="text-align:center; color:black;" id="divToPrintBureau" class="d-none hidden col-md-12 col-sm-12">
          
          <div class="row">
              <div class="block" style="float:left;width:50%;box-sizing: border-box;padding: 15px;">
                  Facture: <strong>{{datafactures.number}}</strong> <br>
                  Séquence: <strong>{{datafactures.sequence}}</strong> <br>
                  Date Facture: <strong :title="datafactures.dateFacture">{{ formatDate(datafactures.dateFacture)}}</strong> <br>
                  <!-- : {{facture.vendeur}}<br> -->
                  <small> <strong>Date du jour :</strong> {{ dateDuJour }}</small>
              </div>
              <div class="block" style="float:left;width:50%;box-sizing: border-box;padding: 15px;">
                  
                  <strong>Patient</strong><br>
                  {{ datafactures?.patient?.nom }} {{ datafactures?.patient?.prenom }}<br>
              {{ datafactures?.patient?.code_dossier }}<br>
              <!-- {{ facture?.patient?.sexe=== 1 ? 'Masculin' : 'Féminin' }} -->
                  
              </div>
              
          </div>
          <br>
          <div class="col-md-12 col-sm-12">
              <table v-if="datafactures?.details?.length>0" class="hidden d-none col-md-12 col-sm-12 table--ben responsive" width="100%" style="border-collapse:collapse; border:1px solid black;" >
                  <thead>
                      <tr>
                          <th style="text-align:left;border: 1px solid black; width: 40%;">Service</th>
                          <th style="text-align:center;border: 1px solid black; width: 20%;">Qté</th>
                          <th style="text-align:center;border: 1px solid black; width: 20%;">Prix unité</th>
                          <th style="text-align:right;border: 1px solid black; width: 20%;">Prix Total</th>
                      </tr>
                  </thead>
                  </table>
                  <div style="border: 1px solid black; height: 300px;">
                              <table class="hidden d-none col-md-12 col-sm-12 responsive" width="100%">
                                  <tbody class="" style="border: 1px solid black;">
                                      <tr v-for="(details,key) in datafactures.details" :key="key">
                                          <td style="text-align:left; width: 40%;">{{ details.service.service}}</td>
                                          <td style="text-align:center; width: 20%;">{{ details.quantite }}</td>
                                          <td style="text-align:center; width: 20%;">{{ details.prix_unitaire }}</td>                                                              
                                          <td style="text-align:right; width: 20%;">{{ details.prix_total}} </td>                                                              
                                      </tr>  
                                  </tbody>
                              </table>
                      </div>
              <br/>
              <table style="float: right; border: 1px solid black; padding:15px;">
                  <tfoot>
                      <tr>
                          <th style="text-align: right;">Sub Total:</th>
                          <th style="text-align: right;">{{ datafactures.sousTotal }} {{ datafactures.indice }}</th>
                      </tr>
                      <tr>
                          <th style="text-align: right;">Rabais:</th>
                          <th style="text-align: right;">{{ datafactures.rabais }} {{ datafactures.indice }}</th>
                      </tr>
                      <!-- <tr>
                          <th style="text-align: right;">Total:</th>
                          <th style="text-align: right;">HTG {{ facture.totalApayer }}</th>
                      </tr> -->
                      <!-- <tr>
                          <th style="text-align: right;">TCA:</th>
                          <th style="text-align: right;">{{ facture.taxe }} {{devizSystem}}</th>
                      </tr> -->
                      <tr>
                          <th style="text-align: right;">GTotal:</th>
                          <th style="text-align: right;">{{ datafactures.totalApayer }} {{ datafactures.indice }}</th>
                      </tr>
                      <tr>
                          <th style="text-align: right;">Montant Offert:</th>
                          <th style="text-align: right;">{{ datafactures.somme_entrer }} {{datafactures.indice}}</th>
                      </tr>
                      <tr>
                          <th style="text-align: right;">{{(datafactures.balance>=0?"Balance":"Monnaie")}}:</th>
                          <th style="text-align: right;">{{ datafactures.balance }} {{ datafactures.indice }}</th>
                      </tr>
                  </tfoot>
              </table>                                            
          </div>
          <!-- <div v-else class="alert alert-info text-info text-center">Aucun élément</div> -->
          <br>
          <!-- <NoteFiche :notes="notes" v-if="notes.length>0"/> -->
          
              
  </div>
<!-- Div Print Bureau End -->

<!-- Div Print Thermal begin-->
<div style="color:black; width: 100%; padding-right: 2%;" id="divToPrintThermale" class="d-none hidden col-md-12 col-sm-12">
      <div class="row">
          <div class="block" style="float:left;width:80%;box-sizing: border-box;">
              <p>#: {{datafactures.number}} <br></p>
              <small> <strong>Date :</strong> {{ dateDuJour }}</small><br>
              <!-- <strong>Vendeur:</strong> {{facture.vendeur}}<br> -->
          <strong>Patient</strong><br>
              {{ datafactures?.patient?.nom }} {{ datafactures?.patient?.prenom }}<br>
          {{ datafactures?.patient?.code_dossier }}<br>
          {{ datafactures?.patient?.sexe=== 1 ? 'Masculin' : 'Féminin' }}
          </div>

      </div>
      <div class="col-md-12 col-sm-12">
          <p style="text-align: center;">************************************* </p>
          <div style="display: flex; flex-wrap: nowrap; width: 90%;" v-if="datafactures?.details?.length>0">
              <div style="text-align:left; width:40%;" >Article</div>
              <div style="text-align:center; width:20%;" >Qté</div>
              <div style="text-align:right; width:20%;" >Prix Uté&nbsp;</div>                                                
              <div style="text-align:right; width:20%;" >Prix Tot.&nbsp;</div>                                                
          </div>
          <div>

              <!-- <tr v-for="(details,key) in facture.details" :key="key">
                      <td style="text-align:left;">{{ details.service.service}}</td>
                      <td style="text-align:center;">{{ details.quantite }}</td>
                      <td style="text-align:center;">{{ details.prix_unitaire }}</td>                                                              
                      <td style="text-align:right;">{{ details.prix_total}} </td>                                                              
              </tr>   -->
              <template v-if="datafactures?.details?.length>0">
                  <div>----------------------------------------</div>
                  <div v-for="(details,i) in datafactures.details" :key="i" style="display: flex; flex-wrap: nowrap; width: 90%;">
                      <div style="text-align:left; width:40%;">{{details.service.service}}</div>
                      <div style="text-align:center; width:20%;">{{details.quantite}}</div>
                      <div style="text-align:right; width:20%;">{{details.prix_unitaire}}</div>                                                              
                      <div style="text-align:right; width:20%;">{{(details.prix_unitaire*details.quantite).toFixed(2)}} </div>                                                              
                  </div> 
                  <p style="text-align: center;">-------------------------------------</p>
                  <br>
              </template>
              
              <p style="text-align: center;">************************************* </p>
              <br>
              
              <div style="text-align: right; width: 100%;">
                  <div>
                      <div>Sub Total: {{datafactures.subtotal}} {{datafactures?.indice}}&nbsp;</div>
                  </div>
                  <div>
                      <div>Rabais: {{ datafactures.rabais }} {{datafactures?.indice}}&nbsp;</div>
                  </div>
                  <div>
                      <div>Total: {{ datafactures.total }} {{datafactures?.indice}}&nbsp;</div>
                  </div>
                  <div>
                      <div>TCA: {{ datafactures.taxe }} {{datafactures?.indice}}&nbsp;</div>
                  </div>
                  <div>
                      <div>GTotal: {{ datafactures.total_a_payer }} {{datafactures?.indice}}&nbsp;</div>
                  </div>
                  <div>
                      <div>Offert: {{ datafactures.somme_entrer }} {{datafactures?.indice}}&nbsp;</div>
                  </div>
                  <div>
                      <div>{{(datafactures.balance>=0?"Balance":"Monnaie")}}: {{ datafactures.balance }} {{datafactures?.indice}}&nbsp;</div>
                  </div>
  
              </div>
          </div>
          <!-- <div v-else class="alert alert-info text-info text-center">Aucun élément</div> -->
          
      </div>
      <br>
      
      <!-- <NoteFiche :notes="notes" v-if="notes.length>0"/> -->
      <br/>
      <div style="width:80%; text-align:center;">
          <small>Merci d'avoir choisi {{ infoEntreprise?.nom }} </small>
      </div>
      <br/>
      <br/>

</div>
<!-- Div Print Thermal End -->


</div>
</DashView>
</template>

<script>
/**
 * facon pour acceder a ce componernt: <router-link name='mon component', params:{data:'hello-world'}></router-link>
 * ou
 * <router-link :to="{name:"mon component",params:{data:'hello-world'}}">Aller au component</router-link>
 */

import $ from 'jquery';
import axios from 'axios'
const base_url=process.env.VUE_APP_API_URL;
import DashView from "@/components/DashView.vue"
export default {
name:"FactureForPrint",
    components:{
        DashView
    },
    data(){
            return{ 
            accessToken:JSON.parse(localStorage.getItem('user_zgh')).token ?? '',
            donnees:JSON.parse(localStorage.getItem('donnees')) ?? [],
            devizSystem: 'Gdes',
            services:JSON.parse(localStorage.getItem('donnees')).service,
            dateDuJour:'',
            save:false,
            facture:'',
            infoEntreprise:[],
            datafactures:[],
            printType:'',
        }
    },
    created(){
    this.Entreprise();
      const aujourdhui = new Date();
      this.dateDuJour = aujourdhui.toLocaleDateString('fr-FR'); 
      console.log(this.donnees);
      console.log('this services');
      console.log(this.services);
    },
    methods:{
    registerFacture(){
        let total = this.donnees.prixTotal;
        delete this.services.specialites;
        // this.$delete(this.services, 'specialites');


        // if (Array.isArray(this.services)) {
        //   total += this.services.reduce((sum, item) => sum + Number(item.prix), 0);
        // }
        // prix principal du service
        // if (this.services && this.services.prix) {
        //   total += Number(this.services.prix);
        // }
        // this.services[0].prix = this.donnees.prixTotal;
        this.services.prix = this.donnees.prixTotal;
        console.log(this.services);
        
        
        console.log("Total :", total);
        const sousTotal = total;  
        const rabais = 0;
        const taxe = 0;
        const $data = {
          patient : this.donnees.patient.code_dossier,
          rabais : rabais,
          service : this.services,
          taxe:taxe,
          sousTotal : sousTotal,
          total : sousTotal - rabais,
          totalApayer : (sousTotal - rabais) + taxe,
          id_declasser:this.donnees.id_declasser
        };
      // console.log($data);
      // return false;

      // --------------------------------------------------
          axios.post(`${base_url}/add_facture`,$data,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
            .then((response)=>{
              console.log('Return data');
              
                console.log(response);
                if(response.status==201){
                  this.facture = response.data.facture;
                  this.success_msg = `Facture enregistrée!`;
                  this.getFacture_(response.data.facture);
                    // location.reload();
                    // this.save = true;
                    const self = this;
                    setTimeout(function() {
                      self.printerFormat();
                      self.redirection();
                      },2000);

                    // localStorage.removeItem('donnees');
                    //! On envoie le code de la facture pour imprimer la facture
                    // this.loadDataForPrintFacture(response.data.facture);
                }
            })
            .catch((error)=>{
                console.log(error);
            })

      // --------------------------------------------------
      
    },
    Entreprise(){
        axios.get(`${base_url}/getInfoEntreprise`,{
                headers:{
                    Accept:'application/json',
                    'Content-Type':'application/json;charset=UTF-8',
                    Authorization:`Bearer ${this.accessToken}`
                }
            })
        .then((response)=>{
            console.log('Entreprise');
            console.log(response.data.entreprise);
            this.infoEntreprise= response?.data?.entreprise ?? [];
            console.log(this.infoEntreprise);            
        })
        .catch((error)=>{
            if(error){
            //! Gérer d'autres erreurs ici
                console.log();('Une erreur est survenue!');
                console.log('Autre erreur:', error);
            }
        })
    },
    printDivBureau(){
        var divToPrint = document.getElementById('divToPrintBureau');
        var popupWin = window.open('', '_blank', 'width=300,height=300');
        // const widths = 30;
        // const widths = this.cprinter ?? '';   
        const email = this.infoEntreprise?.email ?? '';
        const phone = this.infoEntreprise?.telephone ?? '';
        const adresse = this.infoEntreprise?.adresse ?? '';
        const entreprise = this.infoEntreprise?.nom ?? '';
        const logo = this.infoEntreprise?.logo ?? '';
        popupWin.document.open();
       popupWin.document.write('<html><head> <title>' + entreprise + '</title></head><header style="float:center; width:100%"><div style="width:100%; text-align:center;">' 
    + (logo ? `<img style="width:250px;" src="/assets/images/${logo}" alt="">` : `<span><center><strong><h1>${entreprise}</h1></strong></center></span>`) + '</div> <br><div style="text-align:center; width:100%;">'
    + adresse + '</br>' + email + '</br>' + phone + ' <hr class="hr-4"><br> </div></header><body onload="window.print()">' 
    + divToPrint.innerHTML + '</body><footer style="position:absolute;bottom:0; text-align:center;"><div> <small>Merci d\'avoir choisi' 
    + entreprise + '</small> </div></footer></html>');

        popupWin.document.close();
    },
    printDivThermal(){
        const divToPrint = document.getElementById('divToPrintThermale');
        var popupWin = window.open('', '_blank', 'width=300,height=300');
        // const widths = 30;
        // const widths = this.cprinter;
        const email = this.infoEntreprise?.email ?? '';
        const phone = this.infoEntreprise?.telephone ?? '';
        const adresse = this.infoEntreprise?.adresse ?? '';
        const logo = (this.infoEntreprise?.logo)?this.infoEntreprise?.logo:'';
        const entreprise = this.infoEntreprise?.nom ?? '';
    //     popupWin.document.open();
    //    popupWin.document.write('<html><header> <div style="width:100%; text-align:center;"> <img style="width:80%; margin-right:20%;" src="/assets/images/'+logo+'" alt="..." class=""> </div> <div style="text-align: center; width:80%;">'+adresse+'</br>'+email+'</br>'+phone+' <hr class="hr-4"><br> </div></header><body onload="window.print()">' + divToPrint.innerHTML + '</body></html>');
    //     popupWin.document.close();
        

        popupWin.document.open();
       popupWin.document.write('<html><head> <title>' + entreprise + '</title></head><header style="width:100%"><div style="width:100%; text-align:center;">' 
    + (logo ? `<img style="width:250px;" src="/assets/images/${logo}" alt="">` : `<span><center><strong><h1>${entreprise}</h1></strong></center></span>`) + '</div> <br><div style="text-align:center; width:100%;">'
    + adresse + '</br>' + email + '</br>' + phone + ' <hr class="hr-4"><br> </div></header><body onload="window.print()">' 
    + divToPrint.innerHTML + '</body><footer style="position:absolute;bottom:0; text-align:center;"><div> <small>Merci d\'avoir choisi' 
    + entreprise + '</small> </div></footer></html>');
    popupWin.document.close();
    },
    formatDate(dateString) {
            const date = new Date(dateString);
            const day = ('0' + date.getDate()).slice(-2);
            const month = ('0' + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();
            const hours = ('0' + date.getHours()).slice(-2);
            const minutes = ('0' + date.getMinutes()).slice(-2);
            const seconds = ('0' + date.getSeconds()).slice(-2);

            return `${day}-${month}-${year}`;
    },
    getFacture_(code) {
            this.datafactures=[];
            this.status_facture='';
            console.log("Code facture recherché:", code);

            axios.get(`${base_url}/search_facture`, {
                params: {
                    number: code
                },
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: `Bearer ${this.accessToken}`
                }
            })
            .then((response) => {
                console.log('datafactures');
                
                console.log(response.data);
                this.datafactures = response.data;
                this.status_facture = this.facture.status;
                // console.log('status facture: '+this.facture.status);
                
                // this.updateModalContent(response.data); // décommenter si tu veux afficher les infos
            })
            .catch((error) => {
                if (error?.response?.status === 403) {
                    // console.warn('Accès refusé');
                    $('#openModalNoAccess').trigger('click');
                } else if (error?.response?.status === 404) {
                    console.warn('Facture non trouvée');
                    // alert('Aucune facture trouvée.');
                } else {
                    console.error('Une erreur est survenue:', error);
                }
            });
    },
    printerFormat(){
        if(this.printType=='lettre'){
            this.printDivBureau();
        }
        else if(this.printType=='thermal'){
            this.printDivThermal();
        }
    },
    redirection(){
        localStorage.removeItem('donnees');
         this.$router.push('/factures');
    }
    
  }
}
</script>

<style>
@media print {
      .no-print {
        display: none;
      }
    }
    body {
      background-color: #f8f9fa;
      padding: 30px;
    }
    .invoice-box {
      background: #fff;
      padding: 30px;
      border-radius: 10px;
      box-shadow: 0 0 10px rgba(0,0,0,0.1);
      max-width: 900px;
      margin: auto;
    }
    .invoice-header {
      border-bottom: 2px solid #0d6efd;
      margin-bottom: 20px;
      padding-bottom: 10px;
    }
    .invoice-title {
      font-size: 28px;
      font-weight: bold;
    }
    .clinic-logo {
      max-height: 70px;
    }
    .table th, .table td {
      vertical-align: middle;
    }
</style>